import { Box, easeOutQuad, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { clampedInversedLerp, lerp } from '@lemonade-hq/ts-helpers';
import styled from 'styled-components';

const Container = styled(Box)`
  position: relative;
  z-index: 0;

  ${MEDIA_QUERIES.upToDesktop`
        transform: scale(0.5);
    `}
`;

const BubbleContainer = styled.div`
  height: 100%;
  width: 100%;
  transform: translate(50%, 50%);
`;

const Bubble = styled(Box)`
  border-radius: 50%;
  width: 27px;
  height: 27px;
  background-color: ${themedColor('mercury')};
  position: absolute;
`;

const StallBubble = styled(Bubble)`
  opacity: 0.2;
  background-color: ${themedColor('primary')} !important;
`;

const SINGLE_DURATION = 1 / 24;
const OVERLAP = 3;

function bubblesInRadius(amount, radius, t, key) {
  const children = [];

  for (let i = 0; i < amount; i++) {
    const angle = (i * (Math.PI * 2)) / amount - Math.PI / 2;
    const scaleT = clampedInversedLerp(
      (SINGLE_DURATION / OVERLAP) * i,
      (SINGLE_DURATION / OVERLAP) * (i + 1) * OVERLAP,
      t,
    );
    const scale = lerp(0, 1, easeOutQuad(scaleT));
    children.push(
      <Bubble
        key={`${key}-${i * radius}`}
        data-bla={`${key}-${i * radius}`}
        style={{ transform: `scale(${scale})` }}
        top={Math.sin(angle) * radius}
        left={Math.cos(angle) * radius}
      />,
    );
  }

  return children;
}

export default function Giveback2020Speaker({ t, ...props }) {
  return (
    <Container {...props}>
      <BubbleContainer>
        {bubblesInRadius(6, 50, t, 'one')}
        {bubblesInRadius(12, 100, t, 'two')}
        {bubblesInRadius(18, 150, t, 'three')}
        {bubblesInRadius(24, 200, t, 'four')}
        {t === 1 && <StallBubble key="stall-bubble" />}
      </BubbleContainer>
    </Container>
  );
}
